import { useCallback } from "react";
import { useAuthQuery } from "./useAuthQuery";

export const useGetChatClientInfo = (queryBody) => {
  const select = useCallback((response) => {
    return response.data?.data ?? { error: response.data?.error ?? null };
  }, []);

  const response = useAuthQuery(
    {
      method: "POST",
      url: "/chat/clientinfo",
      data: queryBody,
    },
    {
      queryKey: ["chat_client_info", queryBody],
      select,
      refetchOnWindowFocus: false,
    },
  );

  return response;
};
